"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.reports", ["nucont.shared"]);
require("./reports.routes");
